import { render, staticRenderFns } from "./WideParticipationInProjectsData.vue?vue&type=template&id=4b1a5d86&scoped=true&"
import script from "./WideParticipationInProjectsData.vue?vue&type=script&lang=js&"
export * from "./WideParticipationInProjectsData.vue?vue&type=script&lang=js&"
import style0 from "./WideParticipationInProjectsData.vue?vue&type=style&index=0&id=4b1a5d86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a5d86",
  null
  
)

export default component.exports